function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpexBayLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1600px",
    height: "521px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 532.833,-0.5 1066.17,-0.5 1599.5,-0.5C 1599.5,173.167 1599.5,346.833 1599.5,520.5C 1066.17,520.5 532.833,520.5 -0.5,520.5C -0.5,346.833 -0.5,173.167 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7ec347",
    d: "M 274.5,156.5 C 257.833,156.5 241.167,156.5 224.5,156.5C 224.737,155.209 224.404,154.209 223.5,153.5C 222.964,137.791 214.964,128.291 199.5,125C 184.674,121.659 172.174,125.492 162,136.5C 154.435,150.095 154.768,163.428 163,176.5C 168.93,181.763 175.763,185.263 183.5,187C 212.269,185.916 236.769,195.416 257,215.5C 278.538,245.145 281.205,276.478 265,309.5C 250.092,332.382 228.925,345.216 201.5,348C 175.538,351.011 152.204,344.678 131.5,329C 113.087,311.99 104.087,290.824 104.5,265.5C 121.833,265.5 139.167,265.5 156.5,265.5C 155.474,280.96 162.141,291.46 176.5,297C 192.858,302.084 207.025,298.584 219,286.5C 228.242,270.017 225.742,255.517 211.5,243C 201.427,236.732 190.427,234.065 178.5,235C 123.863,225.036 100.029,192.536 107,137.5C 117.465,101.498 141.298,80.665 178.5,75C 213.868,71.1037 242.035,83.2704 263,111.5C 271.325,125.271 275.158,140.271 274.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0381c3",
    d: "M 897.5,80.5 C 913.5,80.5 929.5,80.5 945.5,80.5C 945.333,114.168 945.5,147.835 946,181.5C 965.528,162.821 988.694,155.988 1015.5,161C 1046.66,168.154 1068.82,186.32 1082,215.5C 1089.04,212.77 1096.38,211.437 1104,211.5C 1110.54,211.842 1117.04,212.509 1123.5,213.5C 1136.43,186.764 1157.43,169.597 1186.5,162C 1231.88,153.669 1267.38,168.503 1293,206.5C 1300.15,219.275 1304.48,232.941 1306,247.5C 1306.5,282.498 1306.67,317.498 1306.5,352.5C 1291.17,352.5 1275.83,352.5 1260.5,352.5C 1260.67,346.158 1260.5,339.825 1260,333.5C 1238.73,353.806 1213.56,360.973 1184.5,355C 1153.93,346.103 1132.43,326.936 1120,297.5C 1112.68,277.315 1110.51,256.649 1113.5,235.5C 1105.4,233.988 1097.4,234.321 1089.5,236.5C 1094.98,271.248 1086.48,301.915 1064,328.5C 1039.67,351.275 1010.84,360.441 977.5,356C 931.899,346.398 905.399,318.564 898,272.5C 897.5,208.501 897.333,144.501 897.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef4123",
    d: "M 583.5,155.5 C 616.511,152.334 644.677,162.334 668,185.5C 679.234,199.303 686.734,214.97 690.5,232.5C 690.167,233.167 689.833,233.833 689.5,234.5C 645.409,252.974 601.409,271.641 557.5,290.5C 576.39,312.28 598.723,316.446 624.5,303C 629.879,299.288 634.213,294.621 637.5,289C 654.51,288.167 671.51,288.334 688.5,289.5C 678.428,321.072 657.428,341.239 625.5,350C 579.512,359.789 543.012,345.623 516,307.5C 499.375,277.631 497.042,246.631 509,214.5C 524.16,182.516 548.994,162.85 583.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2d377",
    d: "M 223.5,153.5 C 224.404,154.209 224.737,155.209 224.5,156.5C 241.167,156.5 257.833,156.5 274.5,156.5C 257.675,157.497 240.675,157.83 223.5,157.5C 223.5,156.167 223.5,154.833 223.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef4123",
    d: "M 342.5,331.5 C 342.44,330.957 342.107,330.624 341.5,330.5C 340.5,364.16 340.167,397.827 340.5,431.5C 324.833,431.5 309.167,431.5 293.5,431.5C 293.5,368.833 293.5,306.167 293.5,243.5C 299.551,197.279 325.218,168.445 370.5,157C 423.19,150.252 460.023,171.085 481,219.5C 494.084,264.236 483.584,302.403 449.5,334C 421.119,354.524 390.785,357.857 358.5,344C 352.407,340.733 347.074,336.566 342.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1d376",
    d: "M 756.5,158.5 C 737.326,158.17 718.326,158.503 699.5,159.5C 698.957,159.44 698.624,159.107 698.5,158.5C 717.996,157.172 737.329,157.172 756.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1d376",
    d: "M 820.5,158.5 C 839.671,157.172 859.004,157.172 878.5,158.5C 878.376,159.107 878.043,159.44 877.5,159.5C 858.674,158.503 839.674,158.17 820.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7ec346",
    d: "M 756.5,158.5 C 766.782,174.777 777.449,190.777 788.5,206.5C 799.585,190.754 810.251,174.754 820.5,158.5C 839.674,158.17 858.674,158.503 877.5,159.5C 857.424,189.311 837.09,218.978 816.5,248.5C 839.376,282.42 862.376,316.253 885.5,350C 865.825,350.833 846.158,350.666 826.5,349.5C 814.227,329.896 801.56,310.563 788.5,291.5C 775.337,310.841 762.337,330.341 749.5,350C 729.833,350.667 710.167,350.667 690.5,350C 713.696,316.304 736.696,282.47 759.5,248.5C 739.474,218.816 719.474,189.149 699.5,159.5C 718.326,158.503 737.326,158.17 756.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0281c3",
    d: "M 1325.5,164.5 C 1341.5,164.5 1357.5,164.5 1373.5,164.5C 1373.17,202.337 1373.5,240.004 1374.5,277.5C 1375.41,298.741 1386.41,310.075 1407.5,311.5C 1428.63,311.527 1441.13,301.194 1445,280.5C 1445.5,241.835 1445.67,203.168 1445.5,164.5C 1461.5,164.5 1477.5,164.5 1493.5,164.5C 1493.67,234.167 1493.5,303.834 1493,373.5C 1486.92,413.917 1463.75,437.417 1423.5,444C 1393.61,448.26 1368.11,439.76 1347,418.5C 1337.37,407.563 1331.2,394.896 1328.5,380.5C 1344.99,379.503 1361.66,379.17 1378.5,379.5C 1380.82,388.658 1386.49,394.825 1395.5,398C 1407.53,400.702 1419.19,399.702 1430.5,395C 1436.9,390.262 1441.4,384.095 1444,376.5C 1445.55,365.217 1445.88,353.883 1445,342.5C 1414.24,362.8 1383.74,362.3 1353.5,341C 1337.01,326.182 1327.84,307.682 1326,285.5C 1325.5,245.168 1325.33,204.835 1325.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#add7ec",
    d: "M 1325.5,164.5 C 1341.66,163.504 1357.99,163.17 1374.5,163.5C 1374.5,201.5 1374.5,239.5 1374.5,277.5C 1373.5,240.004 1373.17,202.337 1373.5,164.5C 1357.5,164.5 1341.5,164.5 1325.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefcfc",
    d: "M 589.5,197.5 C 607.173,195.999 622.173,201.499 634.5,214C 605.575,226.589 576.575,239.089 547.5,251.5C 547.209,230.256 556.209,214.089 574.5,203C 579.462,200.726 584.462,198.892 589.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 381.5,200.5 C 412.633,200.139 431.466,215.139 438,245.5C 440.477,269.776 431.643,288.609 411.5,302C 385.544,313.014 364.71,306.847 349,283.5C 339.031,263.807 339.031,244.14 349,224.5C 356.899,212.423 367.732,204.423 381.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 987.5,204.5 C 1018.03,205.196 1036.2,220.529 1042,250.5C 1044.7,277.266 1034.2,296.766 1010.5,309C 979.713,316.357 958.879,305.19 948,275.5C 941.116,249.462 948.282,228.295 969.5,212C 975.27,208.605 981.27,206.105 987.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 1203.5,204.5 C 1232.49,204.915 1250.32,219.248 1257,247.5C 1261.15,274.705 1251.31,294.872 1227.5,308C 1201.93,316.458 1182.1,309.292 1168,286.5C 1155.7,259.637 1159.86,235.803 1180.5,215C 1187.51,209.827 1195.17,206.327 1203.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f26953",
    d: "M 293.5,243.5 C 293.5,306.167 293.5,368.833 293.5,431.5C 309.167,431.5 324.833,431.5 340.5,431.5C 340.5,431.833 340.5,432.167 340.5,432.5C 324.5,432.5 308.5,432.5 292.5,432.5C 292.168,369.331 292.501,306.331 293.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f58f7d",
    d: "M 342.5,331.5 C 341.833,365.167 341.167,398.833 340.5,432.5C 340.5,432.167 340.5,431.833 340.5,431.5C 340.167,397.827 340.5,364.16 341.5,330.5C 342.107,330.624 342.44,330.957 342.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8cc6e4",
    d: "M 1378.5,379.5 C 1361.66,379.17 1344.99,379.503 1328.5,380.5C 1327.96,380.44 1327.62,380.107 1327.5,379.5C 1344.66,378.173 1361.66,378.173 1378.5,379.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpexBayLogo1);
export default __webpack_public_path__ + "static/media/SpexBay Logo-1.df6fc8752cb689fa8378c0bc19670023.svg";
export { ForwardRef as ReactComponent };